import { Routes, RouterModule } from '@angular/router';

import { NavigationFilterGuard } from '@iws-ux/auth';

import { HomeComponent } from './components/home/home.component';

const appRoutes: Routes = [
    {
        path: '', canActivateChild: [NavigationFilterGuard], children: [
            { path: '', component: HomeComponent, pathMatch: 'full' },
            { path: 'home', component: HomeComponent },
            { path: 'signin-oidc', component: HomeComponent, data: { title: 'Home' } },

            {
                path: 'themes',
                loadChildren: () => import('./components/themes/themes.module').then(m => m.ThemesModule)
            },
            {
                path: 'templates',
                loadChildren: () => import('./components/templates/templates.module').then(m => m.TemplatesModule)
            },
            {
                path: 'modules',
                loadChildren: () => import('./components/modules/modules.module').then(m => m.ModulesModule)
            },
        ]
    }
];

export const routing = RouterModule.forRoot(appRoutes);
